/**
 * 무적화물을 이을 수 있는 접수 건을 찾는 질의.
 *
 * **보여 주는 건은 모두 실제로 이어질 수 있어야 한다.** 서버는 두 가지를 거부한다 —
 * 접수 상태가 아닌 건(이미 입고됐거나 취소됐다), 그리고 **번호가 이미 적힌 건**
 * (다른 번호를 덮어쓰면 두 상자의 기록이 섞이고 어느 쪽이 맞는지 되짚을 수 없다).
 * 그래서 목록에서 처음부터 그 둘을 뺀다. 목록에 떴는데 누르면 거부되는 것이
 * 사람에게는 가장 나쁘다.
 *
 * 번호가 틀리게 적힌 건은 여기 나오지 않는다. 그 경우는 접수 화면에서 번호를 고치고
 * 상자를 다시 찍는 것이 맞는 길이다(그러면 스캔이 통하고 무적화물 줄도 저절로 풀린다).
 */

/** 한 번에 보여 줄 수. 창고에서 눈으로 고르는 목록이라 길면 오히려 못 찾는다. */
const PAGE_SIZE = 20

export function candidateQuery(search: string, size: number = PAGE_SIZE): string {
  const params = new URLSearchParams({
    status: "registered",
    hasTracking: "false",
    sort: "receivedOn",
    dir: "desc",
    size: String(size),
  })
  const q = search.trim()
  if (q !== "") params.set("q", q)
  return `/api/cases?${params.toString()}`
}
